import { TaskListComponent } from './task-list/task-list.component';
import { BackgroundUpdateComponent } from './background-update/background-update.component';
import { SuccessTaskUpdateComponent } from './success-task-update/success-task-update.component';
import { FailureTaskUpdateComponent } from './failure-task-update/failure-task-update.component';
import { DetailComponent } from './detail/detail.component';

export const TasksChildRoutes = [
  {
    path: 'task-list',
    component: TaskListComponent, // another child route component that the router renders
  },
  {
    path: 'background-update/:ofuscatedData',
    component: BackgroundUpdateComponent, // another child route component that the router renders
  },
  {
    path: 'detail/:ofuscatedData',
    component: DetailComponent, // another child route component that the router renders
  },
  {
    path: 'success-task-update/:ofuscatedData',
    component: SuccessTaskUpdateComponent, // another child route component that the router renders
  },
  {
    path: 'failure-task-update',
    component: FailureTaskUpdateComponent, // another child route component that the router renders
  },
  {
    path: '',
    pathMatch: 'prefix',
    redirectTo: '/tasks/task-list',
  },
];
